// opervex-frontend/src/Opervex/System/Tenant.js

class Tenant {
  #_api;

  constructor(api) {
    this.#_api = api;
  }

  async findId() {
    return this.#_api.get("/System/Tenant/StartPage/");
  }

  async findByCNPJ(cnpj) {
    return this.#_api.get(`/System/Tenant/FindByCNPJ/${cnpj}`);
  }
}

export default Tenant;
